import React from 'react';
import classnames from 'classnames/bind';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { S2STestLinkGenerator } from '../S22GenerateTestLink/S2STestLinkGenerator';
import styles from './serverEvents.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ServerEvents = () => {
    return (
        <div className={classNameBuilder('server-events-container')}>
            <div className={classNameBuilder('how-it-works-section')}>
                <FormattedMessage
                    id="pixel.tester.website.instructions.title"
                    defaultMessage="How it works"
                    className={classNameBuilder('section-title')}
                />

                <FormattedMessage
                    id="pixel.tester.server.events.step.1.text"
                    defaultMessage="<b>Step 1</b>: Ensure that Server-to-Server is properly integrated in the account."
                />

                <FormattedMessage
                    id="pixel.tester.server.events.step.2.text"
                    defaultMessage="<b>Step 2</b>: Select the campaign that you would like to test."
                />

                <FormattedMessage
                    id="pixel.tester.server.events.step.3.text"
                    defaultMessage="<b>Step 3</b>: Generate a test link by clicking the button below."
                />
            </div>

            <S2STestLinkGenerator />
        </div>
    );
};
